/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPointOutline = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M15.313 12.666A2.813 2.813 0 1 0 12.5 15.48v1.688l-.232-.006a4.5 4.5 0 0 1-4.262-4.263L8 12.666a4.5 4.5 0 0 1 4.5-4.5l.231.006A4.5 4.5 0 0 1 17 12.666l-.006.232a4.5 4.5 0 0 1-4.494 4.268V15.48a2.813 2.813 0 0 0 2.813-2.813" /></svg>;
export default SvgPointOutline;